export default class IDW {
  constructor({
    mapDiv,
    polygonBounds,
    imagePath,
    imageBounds,
    parameterMapInfo
  }) {
    this.mapDiv = mapDiv
    this.polygonBounds = polygonBounds
    this.imagePath = imagePath
    this.imageBounds = imageBounds
    this.parameterMapInfo = parameterMapInfo
    this.googleHybridUrl = "http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}"
    this.maxZoom = 20
    this.subdomains = ["mt0", "mt1", "mt2", "mt3"]
    this.map = new window.L.Map(this.mapDiv, {
      zoomControl: false,
      attributionControl: false,
      center: [35.589887, 59.409615],
    })
    this.gglHybrid = window.L.tileLayer(this.googleHybridUrl, {
      maxZoom: this.maxZoom,
      subdomains: this.subdomains,
    })
    this.gglHybrid.addTo(this.map)
    this.polygon = window.L.polygon(polygonBounds).setStyle({ fillOpacity: 0, weight: 2, color: `rgba(${parameterMapInfo?.mapInfo?.ranges[parameterMapInfo?.mapInfo?.ranges?.length - 1]?.color[0]},${parameterMapInfo?.mapInfo?.ranges[parameterMapInfo?.mapInfo?.ranges?.length - 1]?.color[1]},${parameterMapInfo?.mapInfo?.ranges[parameterMapInfo?.mapInfo?.ranges?.length - 1]?.color[2]},${parameterMapInfo?.mapInfo?.ranges[parameterMapInfo?.mapInfo?.ranges?.length - 1]?.color[3]})` }).addTo(this.map)
    this.map.fitBounds(this.polygon.getBounds())
    
    window.L.imageOverlay(process.env.REACT_APP_ARVAN_S3_BASE_URL + this.imagePath + `?${Date.now()}`, this.imageBounds).addTo(this.map)
  }
}